import { createFileRoute } from "@tanstack/react-router";
import { StrengthLog } from "@/features/logs";

/**
 * THE STRENGTH LOG — pushed from the session, one set at a time.
 *
 * The screen owns its own 52px header bar and its own footer, the way the session screen it is
 * pushed from does, so the route renders it whole rather than putting a title above it. A
 * screen that starts with content and a screen that starts with a header bar cannot share one
 * frame, and the header is what carries "Set 3 / 5".
 */
export const Route = createFileRoute("/_app/session/$id/strength")({
  component: StrengthScreen,
});

function StrengthScreen() {
  const { id } = Route.useParams();

  return <StrengthLog sessionId={id} />;
}
